// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.PasswordComplexity.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import constants from 'logic/data/Izenda.SecurityPoliciesConstant';
import action from 'modules/Settings/SystemConfiguration/SecurityPolicies/Izenda.SecurityPoliciesDetailAction';
import EventsUtils from 'EventUtils';

import GridLayout from 'share/components/controls/Izenda.GridLayout';
import Validator from 'share/components/hoc/Izenda.Validator';
import Input from 'share/components/controls/Izenda.Input';
const ValidatableInput = Validator()(Input);
const notifyChange = EventsUtils.notifyChange;

const PasswordComplexity = connect(action)(function(props: any) {
  const localization = props.localization;
  return (
    <GridLayout>
      <GridLayout.Row className='u_noMarginAll u_borderBottom izenda-ItemContentHeight'>
        <GridLayout.Col cols='12' className='u_noPaddingAll'>
          <span className='u_textBold u_marginLeft'>
            {localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_PASSWORD_COMPLEXITY')}
          </span>
        </GridLayout.Col>
      </GridLayout.Row>

      <PasswordLength {...props} />
      <NumberSpecialCharacters {...props} />
      <NumberUppercaseCharacters {...props} />
      <NumberLowercaseCharacters {...props} />
      <NumberNumericCharacters {...props} />
      <NumberSequentialRepeatedCharacters {...props} />
    </GridLayout>
  );
});

const PasswordLength = connect(action)(function(props: any) {
  const localization = props.localization;
  const model = props.store.model;
  const minField = 'minNumberOfPasswordLenght';
  const maxField = 'maxNumberOfPasswordLenght';
  const validateField = [minField, maxField];
  const validations = function(isMinField, sumValue) {
    return constants.numberLimitConstraints(
      isMinField,
      localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_MIN_PASSWORD_LENGTH'),
      localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_MAX_PASSWORD_LENGTH'),
      model[minField],
      model[maxField],
      sumValue
    );
  };
  return (
    <GridLayout.Row className='u_noMarginAll u_borderBottom izenda-ItemContentHeight'>
      <GridLayout.Col cols='12' className='u_noPaddingAll'>
        <GridLayout.Col cols='4'>
          <label>
            <Input
              type='checkbox'
              className='u_marginLeft'
              checked={model.passwordLength}
              onChange={notifyChange(props.onChangeValueCheckbox.bind(props, 'passwordLength'), EventsUtils.CHECKBOX)}
            />
            <span className='u_marginLeft'>
              {localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_PASSWORD_LENGTH')}
            </span>
          </label>
        </GridLayout.Col>
        <GridLayout.Col cols='8'>
          <span>{localization.getText('COMMON_LABEL_FROM')}</span>
          <ValidatableInput
            type='input'
            containerClassName='u_inline'
            className='izenda-CustomInput form-control u_inlineBlock u_marginLeftRight'
            disabled={!model.passwordLength}
            value={model[minField]}
            onBlur={props.onBlurFocusField.bind(props, validateField)}
            field={minField}
            validations={validations(true, model.minPasswordLength)}
            onChange={notifyChange(model.updateValueByKey.bind(model, minField), EventsUtils.INPUT)}
          />
          <span>{localization.getText('COMMON_LABEL_TO')}</span>
          <ValidatableInput
            type='input'
            containerClassName='u_inline'
            className='izenda-CustomInput form-control u_inlineBlock u_marginLeftRight'
            disabled={!model.passwordLength}
            value={model[maxField]}
            onBlur={props.onBlurFocusField.bind(props, validateField)}
            field={maxField}
            validations={validations(false, model.maxPasswordLength)}
            onChange={notifyChange(model.updateValueByKey.bind(model, maxField), EventsUtils.INPUT)}
          />
        </GridLayout.Col>
      </GridLayout.Col>
    </GridLayout.Row>
  );
});

const NumberSpecialCharacters = connect(action)(function(props: any) {
  const localization = props.localization;
  const model = props.store.model;
  const minField = 'minNumberOfSpecialCharacter';
  const maxField = 'maxNumberOfSpecialCharacter';
  const validateField = [minField, maxField, 'minNumberOfPasswordLenght', 'maxNumberOfPasswordLenght'];
  const validations = function(isMinField) {
    return constants.numberLimitConstraints(
      isMinField,
      'Min No. of Special Characters',
      'Max No. of Special Characters',
      model[minField],
      model[maxField]
    );
  };
  return (
    <GridLayout.Row className='u_noMarginAll u_borderBottom izenda-ItemContentHeight'>
      <GridLayout.Col cols='12' className='u_noPaddingAll'>
        <GridLayout.Col cols='4'>
          <label>
            <Input
              type='checkbox'
              className='u_marginLeft'
              checked={model.numberSpecialCharacters}
              onChange={notifyChange(
                props.onChangeValueCheckbox.bind(props, 'numberSpecialCharacters'),
                EventsUtils.CHECKBOX
              )}
            />
            <span className='u_marginLeft'>
              {localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_NO_OF_SPECIAL_CHARACTERS')}
            </span>
          </label>
        </GridLayout.Col>
        <GridLayout.Col cols='8'>
          <span>{localization.getText('COMMON_LABEL_FROM')}</span>
          <ValidatableInput
            type='input'
            containerClassName='u_inline'
            className='izenda-CustomInput form-control u_inlineBlock u_marginLeftRight'
            field={minField}
            disabled={!model.numberSpecialCharacters}
            value={model[minField]}
            onBlur={props.onBlurFocusField.bind(props, validateField)}
            onChange={notifyChange(
              props.onChangeSettingValueMinPasswordLength.bind(props, minField),
              EventsUtils.INPUT
            )}
            validations={validations(true)}
          />
          <span>{localization.getText('COMMON_LABEL_TO')}</span>
          <ValidatableInput
            type='input'
            containerClassName='u_inline'
            className='izenda-CustomInput form-control u_inlineBlock u_marginLeftRight'
            field={maxField}
            disabled={!model.numberSpecialCharacters}
            value={model[maxField]}
            onBlur={props.onBlurFocusField.bind(props, validateField)}
            onChange={notifyChange(
              props.onChangeSettingValueMaxPasswordLength.bind(props, maxField),
              EventsUtils.INPUT
            )}
            validations={validations(false)}
          />
        </GridLayout.Col>
      </GridLayout.Col>
    </GridLayout.Row>
  );
});

const NumberUppercaseCharacters = connect(action)(function(props: any) {
  const localization = props.localization;
  const model = props.store.model;
  const minField = 'minNumberOfUppercaseCharacter';
  const maxField = 'maxNumberOfUppercaseCharacter';
  const validateField = [minField, maxField, 'minNumberOfPasswordLenght', 'maxNumberOfPasswordLenght'];
  const validations = function(isMinField) {
    return constants.numberLimitConstraints(
      isMinField,
      localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_MIN_NO_OF_UPPERCASE_CHARACTERS'),
      localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_MAX_NO_OF_UPPERCASE_CHARACTERS'),
      model[minField],
      model[maxField]
    );
  };
  return (
    <GridLayout.Row className='u_noMarginAll u_borderBottom izenda-ItemContentHeight'>
      <GridLayout.Col cols='12' className='u_noPaddingAll'>
        <GridLayout.Col cols='4'>
          <label>
            <Input
              type='checkbox'
              className='u_marginLeft'
              checked={model.numberUppercaseCharacters}
              onChange={notifyChange(
                props.onChangeValueCheckbox.bind(props, 'numberUppercaseCharacters'),
                EventsUtils.CHECKBOX
              )}
            />
            <span className='u_marginLeft'>
              {localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_NO_OF_UPPERCASE_CHARACTERS')}
            </span>
          </label>
        </GridLayout.Col>
        <GridLayout.Col cols='8'>
          <span>{localization.getText('COMMON_LABEL_FROM')}</span>
          <ValidatableInput
            type='input'
            containerClassName='u_inline'
            className='izenda-CustomInput form-control u_inlineBlock u_marginLeftRight'
            field={minField}
            disabled={!model.numberUppercaseCharacters}
            value={model[minField]}
            onBlur={props.onBlurFocusField.bind(props, validateField)}
            onChange={notifyChange(
              props.onChangeSettingValueMinPasswordLength.bind(props, minField),
              EventsUtils.INPUT
            )}
            validations={validations(true)}
          />
          <span>{localization.getText('COMMON_LABEL_TO')}</span>
          <ValidatableInput
            type='input'
            containerClassName='u_inline'
            className='izenda-CustomInput form-control u_inlineBlock u_marginLeftRight'
            field={maxField}
            disabled={!model.numberUppercaseCharacters}
            value={model[maxField]}
            onBlur={props.onBlurFocusField.bind(props, validateField)}
            onChange={notifyChange(
              props.onChangeSettingValueMaxPasswordLength.bind(props, maxField),
              EventsUtils.INPUT
            )}
            validations={validations(false)}
          />
        </GridLayout.Col>
      </GridLayout.Col>
    </GridLayout.Row>
  );
});

const NumberLowercaseCharacters = connect(action)(function(props: any) {
  const localization = props.localization;
  const model = props.store.model;
  const minField = 'minNumberOfLowercaseCharacter';
  const maxField = 'maxNumberOfLowercaseCharacter';
  const validateField = [minField, maxField, 'minNumberOfPasswordLenght', 'maxNumberOfPasswordLenght'];
  const validations = function(isMinField) {
    return constants.numberLimitConstraints(
      isMinField,
      localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_MIN_NO_OF_LOWERCASE_CHARACTERS'),
      localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_MAX_NO_OF_LOWERCASE_CHARACTERS'),
      model[minField],
      model[maxField]
    );
  };
  return (
    <GridLayout.Row className='u_noMarginAll u_borderBottom izenda-ItemContentHeight'>
      <GridLayout.Col cols='12' className='u_noPaddingAll'>
        <GridLayout.Col cols='4'>
          <label>
            <Input
              type='checkbox'
              className='u_marginLeft'
              checked={model.numberLowercaseCharacters}
              onChange={notifyChange(
                props.onChangeValueCheckbox.bind(props, 'numberLowercaseCharacters'),
                EventsUtils.CHECKBOX
              )}
            />
            <span className='u_marginLeft'>
              {localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_NO_OF_LOWERCASE_CHARACTERS')}
            </span>
          </label>
        </GridLayout.Col>
        <GridLayout.Col cols='8'>
          <span>{localization.getText('COMMON_LABEL_FROM')}</span>
          <ValidatableInput
            type='input'
            containerClassName='u_inline'
            className='izenda-CustomInput form-control u_inlineBlock u_marginLeftRight'
            field={minField}
            disabled={!model.numberLowercaseCharacters}
            onBlur={props.onBlurFocusField.bind(props, validateField)}
            value={model[minField]}
            onChange={notifyChange(
              props.onChangeSettingValueMinPasswordLength.bind(props, minField),
              EventsUtils.INPUT
            )}
            validations={validations(true)}
          />
          <span>{localization.getText('COMMON_LABEL_TO')}</span>
          <ValidatableInput
            type='input'
            containerClassName='u_inline'
            className='izenda-CustomInput form-control u_inlineBlock u_marginLeftRight'
            disabled={!model.numberLowercaseCharacters}
            value={model[maxField]}
            onBlur={props.onBlurFocusField.bind(props, validateField)}
            field={maxField}
            onChange={notifyChange(
              props.onChangeSettingValueMaxPasswordLength.bind(props, maxField),
              EventsUtils.INPUT
            )}
            validations={validations(false)}
          />
        </GridLayout.Col>
      </GridLayout.Col>
    </GridLayout.Row>
  );
});

const NumberNumericCharacters = connect(action)(function(props: any) {
  const localization = props.localization;
  const model = props.store.model;
  const minField = 'minNumberOfNumericCharacter';
  const maxField = 'maxNumberOfNumericCharacter';
  const validateField = [minField, maxField, 'minNumberOfPasswordLenght', 'maxNumberOfPasswordLenght'];
  const validations = function(isMinField) {
    return constants.numberLimitConstraints(
      isMinField,
      localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_MIN_NO_OF_NUMBERIC_CHARACTERS'),
      localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_MAX_NO_OF_NUMBERIC_CHARACTERS'),
      model[minField],
      model[maxField]
    );
  };
  return (
    <GridLayout.Row className='u_noMarginAll u_borderBottom izenda-ItemContentHeight'>
      <GridLayout.Col cols='12' className='u_noPaddingAll'>
        <GridLayout.Col cols='4'>
          <label>
            <Input
              type='checkbox'
              className='u_marginLeft'
              checked={model.numberNumericCharacters}
              onChange={notifyChange(
                props.onChangeValueCheckbox.bind(props, 'numberNumericCharacters'),
                EventsUtils.CHECKBOX
              )}
            />
            <span className='u_marginLeft'>
              {localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_NO_OF_NUMBERIC_CHARACTERS')}
            </span>
          </label>
        </GridLayout.Col>
        <GridLayout.Col cols='8'>
          <span>{localization.getText('COMMON_LABEL_FROM')}</span>
          <ValidatableInput
            type='input'
            containerClassName='u_inline'
            className='izenda-CustomInput form-control u_inlineBlock u_marginLeftRight'
            disabled={!model.numberNumericCharacters}
            field={minField}
            onBlur={props.onBlurFocusField.bind(props, validateField)}
            value={model[minField]}
            onChange={notifyChange(
              props.onChangeSettingValueMinPasswordLength.bind(props, minField),
              EventsUtils.INPUT
            )}
            validations={validations(true)}
          />
          <span>{localization.getText('COMMON_LABEL_TO')}</span>
          <ValidatableInput
            type='input'
            containerClassName='u_inline'
            className='izenda-CustomInput form-control u_inlineBlock u_marginLeftRight'
            disabled={!model.numberNumericCharacters}
            field={maxField}
            onBlur={props.onBlurFocusField.bind(props, validateField)}
            value={model[maxField]}
            onChange={notifyChange(
              props.onChangeSettingValueMaxPasswordLength.bind(props, maxField),
              EventsUtils.INPUT
            )}
            validations={validations(false)}
          />
        </GridLayout.Col>
      </GridLayout.Col>
    </GridLayout.Row>
  );
});

const NumberSequentialRepeatedCharacters = connect(action)(function(props: any) {
  const localization = props.localization;
  const model = props.store.model;
  const field = 'maxNumberSequentialRepeated';
  const validateField = 'maxNumberOfRepeatSequential';
  return (
    <GridLayout.Row className='u_noMarginAll u_borderBottom izenda-ItemContentHeight'>
      <GridLayout.Col cols='12' className='u_noPaddingAll'>
        <GridLayout.Col cols='4'>
          <label>
            <Input
              type='checkbox'
              className='u_marginLeft'
              checked={model[field]}
              onChange={notifyChange(props.onChangeValueCheckbox.bind(props, field), EventsUtils.CHECKBOX)}
            />
            <span className='u_marginLeft'>
              {localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_MAX_NO_OF_REPEAT_CHARACTERS')}
            </span>
          </label>
        </GridLayout.Col>
        <GridLayout.Col cols='8'>
          <ValidatableInput
            type='input'
            containerClassName='u_inline'
            className='izenda-CustomInput-Position form-control u_inlineBlock'
            disabled={!model[field]}
            value={model[validateField]}
            onBlur={props.onBlurFocusField.bind(props, [validateField])}
            field={validateField}
            onChange={notifyChange(model.updateValueByKey.bind(model, validateField), EventsUtils.INPUT)}
            validations={constants.requiredConstraints(
              localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_MIN_PASSWORD_AGE')
            )}
          />
        </GridLayout.Col>
      </GridLayout.Col>
    </GridLayout.Row>
  );
});

export default PasswordComplexity;



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/SecurityPolicies/PasswordPolicies/Izenda.PasswordComplexity.js